/**
 * Skeleton loader for history sidebar while sessions are loading
 * Matches the actual AppSidebar structure with grouped sessions
 */
export function AppSidebarSkeleton() {
  // Skeleton for a single session item - single bar that spans full width with height
  const SessionItemSkeleton = ({
    delay = 0,
    width = 'w-full',
  }: {
    delay?: number;
    width?: string;
  }) => (
    <div
      className={`px-3 py-1.5 rounded-md animate-pulse ${width}`}
      style={{ animationDelay: `${delay}ms` }}
    >
      {/* Single skeleton bar representing the entire session item */}
      <div className='h-7 bg-surface-muted/60 rounded-md' />
    </div>
  );

  // Skeleton for a group header - matches SessionList group header styling
  const GroupHeaderSkeleton = ({ width }: { width: string }) => (
    <div className='px-2 py-1.5 my-2'>
      <div
        className={`h-[0.625rem] bg-surface-muted/70 rounded-md ${width} animate-pulse`}
      />
    </div>
  );

  return (
    <div className=''>
      <ul className='space-y-1.5 px-3 pt-1.5 pb-1.5 pr-0'>
        {/* First group - "Today" */}
        <div>
          <GroupHeaderSkeleton width='w-1/4' />
          {[0, 1, 2].map((index) => (
            <li key={`today-${index}`} className='my-1'>
              <SessionItemSkeleton delay={index * 50} width='w-full' />
            </li>
          ))}
        </div>

        {/* Second group - "Previous 7 Days" */}
        <div>
          <GroupHeaderSkeleton width='w-1/3' />
          {[0, 1, 2, 3, 4].map((index) => (
            <li key={`week-${index}`} className='my-1'>
              <SessionItemSkeleton delay={(index + 3) * 50} width='w-full' />
            </li>
          ))}
        </div>

        {/* Third group - "Previous 30 Days" */}
        <div>
          <GroupHeaderSkeleton width='w-2/5' />
          {[0, 1, 2, 3].map((index) => (
            <li key={`month-${index}`} className='my-1'>
              <SessionItemSkeleton delay={(index + 8) * 50} width='w-full' />
            </li>
          ))}
        </div>
      </ul>
    </div>
  );
}
